import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "components/ui_new/index";
import { startChat } from "actions/chat";
import { useDispatch } from "react-redux";
import moment from "moment";
import useTranslate from "hooks/use-translate-language";
import { getJoinAriaLabel } from "./appointment-utils";

const JoinChatButton = ({
  slot_id,
  master_chat_type,
  // chat_type,
  chat_type_text,
  is_product_demo,
  start_time,
  date_time,
  dme_details,
  mobileCard = false
}) => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const [seconds, setSeconds] = React.useState(0);
  const [isActive] = React.useState(true);
  const [isFetching, setIsFetching] = useState(false);

  React.useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds(seconds => seconds + 1);
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);
  const isJoinable = moment().isAfter(moment(start_time));
  return (
    <>
      {isJoinable ? (
        <Button
          variant="contained"
          className={`${mobileCard ? "mobile-primary-button" : ""}`}
          color="primary"
          id="join-button"
          disabled={isFetching}
          onClick={async () => {
            try {
              setIsFetching(true);
              await dispatch(
                startChat(slot_id, master_chat_type, is_product_demo)
              );
            } finally {
              setIsFetching(false);
            }
          }}
          style={{
            width: "100%",
            maxWidth: mobileCard ? "100%" : "15rem",
            minWidth: mobileCard ? "auto" : "10rem"
          }}
          aria-label={getJoinAriaLabel({ dme_details, date_time, start_time })}
        >
          {translate("join")} {chat_type_text}
        </Button>
      ) : null}
    </>
  );
};

JoinChatButton.propTypes = {
  chat_type: PropTypes.number,
  slot_id: PropTypes.string,
  start_time: PropTypes.string,
  date_time: PropTypes.string,
  chat_type_text: PropTypes.string,
  master_chat_type: PropTypes.string.isRequired,
  is_product_demo: PropTypes.bool,
  dme_details: PropTypes.object
};

export default JoinChatButton;
